import React from 'react'
import styled from 'styled-components'
import FeatureCard from './commonComponent/FeatureCard'

const LandingFeatureBox = () => {
    return (
        <Box>
            <span className='mainTitle'>Why Choose Brain Quiz?</span>
            <div className='mainBox'>
                <FeatureCard title='AI-Enhanced Learning' text='Say goodbye to traditional study materials. Our AI-driven platform adapts to your unique learning style. It identifies your strengths and weaknesses, enabling you to focus on areas that need improvement.' />
                <FeatureCard title='Personalized Feedback' text='After taking the test, receive AI-generated feedback for your wrong answers. Simply click on the provided button next to each incorrect choice to access valuable insights.' />
                <FeatureCard title='Unlimited Practice' text="Whether you're preparing for tech exams, job interviews, or just enhancing your skills, you'll find a vast collection of MCQs covering various tech topics and difficulty levels." />
                <FeatureCard title='Progress Tracking' text='Monitor your tech learning journey. Our platform records your scores and pinpoints areas for growth, providing suggestions to help you unlock your full tech potential.' />
                <FeatureCard title="Cutting-Edge Features" text='Explore our innovative features designed for a comprehensive learning experience. Enjoy timed quizzes, performance analytics, and a user-friendly interface. Stay tuned for upcoming features aimed at enhancing your tech mastery.' />
                <FeatureCard title='Convenience and Accessibility' text="AI-Driven MCQ Practice is available 24/7. Study and practice at your convenience." />
            </div>
        </Box>
    )
}

export default LandingFeatureBox


const Box = styled.div`
display: flex;
width: 90%;
margin: 7.5rem auto;
flex-direction: column;
align-items: center;
background-color: var(--background-color);

.mainTitle {
    font-size: 4rem;
    font-weight: 600;
    margin-bottom: 3rem;
    color: var(--color);
}

.mainBox {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    gap: 3rem;
    color: var(--color);
}


`